﻿
(function (DealPage) {
    var vehicleOptionsActive = $('#FactoryOrderSteps').length ? true : false;

    let gaSessionId = "";

    var InitFacebookAddToCart = function (currency, value, content_name, content_ids, num_items, content_type) {
        // if (typeof fbq !== "undefined") {
        //     fbq('track', 'AddToCart', {
        //         currency: currency,
        //         value: value,
        //         content_name: content_name,
        //         content_type: content_type,
        //         content_ids: content_ids,
        //         num_items: num_items,
        //     });
        // }
    }

    DealPage.ViewModel = function (monthlyDealPrice, companyName, profileGuid, manufacturer, range, derivative, dealIdentifier, sessionReference,
        financeType, capId, vehicleType, specificationDate, calculator) {
        var self = this;

        self.vehicleOptionsActive = vehicleOptionsActive;
        self.enquiryInProgress = ko.observable(false);
        self.enquiryCompleted = ko.observable(false);
        self.enquirerHasVisitorAccount = ko.observable(false);
        self.marketingOptedIn = ko.observable(false);

        self.hasUplift = function () {
            if (!vehicleOptionsActive) {
                return false;
            } else {
                return monthlyDealPrice !== parseFloat(self.summary.totalMonthlyPrice());
            }
        };

        self.enquiryPhonenumber = ko.observable("");
        self.disableTelEnquiry = ko.observable(false);
        self.telEnquiryCtaText = ko.observable("Call");

        self.isCallbackEnquiry = ko.observable(false);
        self.enquiryFormTitle = ko.observable("Get a free, no obligation quote");
        self.enquiryFormCta = ko.observable("Request a quote");


        self.callNow = function () {
            if (!self.enquiryPhonenumber()) {
                let antiForgeryToken = $("[name=__RequestVerificationToken]").val();
                const gaClientId = window["getClientId"]();
                const urlParams = new URLSearchParams(window.location.search);
                const gaClickId = urlParams.get('gclid');
                const bingAdsClickId = urlParams.get('msclkid');

                $.ajax({
                    url: "/FreeSpee/GetDynamicNumbers",
                    headers: { "x-csrf-token": antiForgeryToken },
                    method: "POST",
                    data: {
                        dealIdentifier,
                        dealLink: $("#hidReferrer").val(),
                        gaClientId: gaClientId,
                        gaSessionId: gaSessionId,
                        gaClickId: gaClickId,
                        bingAdsClickId: bingAdsClickId,
                        utm_source: sessionStorage.getItem("utm_source"),
                        utm_medium: sessionStorage.getItem("utm_medium"),
                        utm_campaign: sessionStorage.getItem("utm_campaign"),
                        utm_term: sessionStorage.getItem("utm_term"),
                        utm_content: sessionStorage.getItem("utm_content"),
                    }
                }).done(function (data) {
                    let telNumber = "";

                    if (data.success && data.numbers && data.numbers.length > 0) {
                        telNumber = data.numbers[0].replace_with.local
                        Modal.show(document.getElementById("tel-enquiry-modal"));
                    } else {
                        self.disableTelEnquiry(true);
                        self.telEnquiryCtaText("Unavailable")
                    }

                    self.enquiryPhonenumber(telNumber);
                })
            } else {
                Modal.show(document.getElementById("tel-enquiry-modal"));
            }
        };

        self.startEnquiry = function () {
            var emailAddress = $("#txtFrom").val();
            if (emailAddress) {
                $.get(`/account/marketing-optin-status?emailAddress=${emailAddress}`)
                    .then(function (optInStatus) {
                        // update the opt-in checkbox
                        document.getElementById("MarketingOptedin").checked = optInStatus !== "OptOut";
                    });
            }

            if (vehicleOptionsActive) {
                self.navigation.initCustomNavigation();
            }

            self.enquiryFormTitle("Get a free, no obligation quote");
            self.enquiryFormCta("Request a quote");
            self.isCallbackEnquiry(false);
            self.enquiryInProgress(true);
            DealPage.scrollToEnquirySteps();

            DealPage.EnquiryForm.setupEnquiryForm();
            InitFacebookAddToCart("GBP", "14.00", manufacturer + "|" + range, financeType.toLowerCase() + "_" + vehicleType.toLowerCase() + "_" + capId, "1", "Product");
            RecordStatistic("EmailEnquiryStarted", "Deal", profileGuid, dealIdentifier, sessionReference);
        };

        self.sendtofriend = function () {
            Modal.show(document.getElementById("sendtofriend-modal"));
        }

        self.requestCallback = function () {
            var emailAddress = $("#txtFrom").val();
            if (emailAddress) {
                $.get(`/account/marketing-optin-status?emailAddress=${emailAddress}`)
                    .then(function (optInStatus) {
                        // update the opt-in checkbox
                        document.getElementById("MarketingOptedin").checked = optInStatus !== "OptOut";
                    });
            }

            if (vehicleOptionsActive) {
                self.navigation.initCustomNavigation();
            }

            self.enquiryFormTitle("Request a callback");
            self.enquiryFormCta("Request a callback");
            self.isCallbackEnquiry(true);
            self.enquiryInProgress(true);
            DealPage.scrollToEnquirySteps();

            DealPage.EnquiryForm.setupEnquiryForm();
            InitFacebookAddToCart("GBP", "14.00", manufacturer + "|" + range, financeType.toLowerCase() + "_" + vehicleType.toLowerCase() + "_" + capId, "1", "Product");
        };

        self.cancelEnquiry = function () {
            self.enquiryInProgress(false);
            DealPage.scrollToEnquirySteps();
        };

        self.submitEnquiryForm = function () {
            $("#EnquiryForm").submit();
        };

        self.yourDetails = {
            stepState: ko.observable(vehicleOptionsActive ? "" : "active")
        };
    };

})(DealPage || (DealPage = {}));